if (!customElements.get('klaim-shop-the-fit')) {
  customElements.define('klaim-shop-the-fit', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.addEventListener('click', (event) => {
        const opener = event.target.closest('[data-fit-open]');
        if (opener) {
          const dialog = document.getElementById(opener.dataset.fitOpen);
          if (!dialog || dialog.open) return;
          this.closeFit();
          this.opener = opener;
          this.previousOverflow = document.documentElement.style.overflow;
          document.documentElement.style.overflow = 'hidden';
          this.activeDialog = dialog;
          dialog.showModal();
        }
        if (event.target.closest('[data-fit-close]')) this.closeFit();
        if (event.target === this.activeDialog) {
          const rect = this.activeDialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.closeFit();
        }
      }, options);
      this.querySelectorAll('dialog').forEach(dialog => {
        dialog.addEventListener('close', () => {
          if (this.activeDialog === dialog && !dialog.open) this.restore();
        }, options);
        dialog.addEventListener('cancel', event => {
          event.preventDefault();
          this.closeFit();
        }, options);
      });
      this.addEventListener('shopify:block:select', event => {
        event.target.querySelector('[data-fit-open]')?.click();
      }, options);
    }
    closeFit() {
      this.activeDialog?.close();
      this.restore();
    }
    restore() {
      if (!this.activeDialog) return;
      document.documentElement.style.overflow = this.previousOverflow;
      this.activeDialog = null;
      if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
    }
    disconnectedCallback() {
      this.closeFit();
      this.events?.abort();
    }
  });
}
